import { graphql } from '@/gql';
import type { FetchPartnerSubsidyLocationsQuery, FetchPartnerSubsidyLocationsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchPartnerSubsidyLocationsInput = FetchPartnerSubsidyLocationsQueryVariables;

export type FetchPartnerSubsidyLocationsOutput = FetchPartnerSubsidyLocationsQuery['partnerSubsidyLocations'];

export const fetchPartnerSubsidyLocations = async ({
  address,
  callerId,
}: FetchPartnerSubsidyLocationsInput): Promise<FetchPartnerSubsidyLocationsOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchPartnerSubsidyLocations($callerId: String!, $address: AddressInputType!) {
        partnerSubsidyLocations(callerId: $callerId, address: $address) {
          name
          phoneNumber
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          country
          latitude
          longitude
          radius
          data
        }
      }
    `),
    variables: {
      callerId,
      address,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.partnerSubsidyLocations;
};
